<template>
  <div class="laboratory-help-tab w-100">
    <div class="ap-title ap-title__main px-3 pt-3 pb-2">
      <span>{{ $tc('global.laboratory') }}</span>
    </div>
    <div class="px-3">
      <shortcuts-and-voice-commands-table :table-data="laboratoryShortcuts" />
    </div>
  </div>
</template>

<script>
import ShortcutsAndVoiceCommandsTable from '@/components/help/shortcutsAndVoiceCommands/ShortcutsAndVoiceCommandsTable'

export default {
    name: 'LaboratoryHelpTab',
    components: {
        ShortcutsAndVoiceCommandsTable
    },
    data() {
        return {
            laboratoryShortcuts: [
                {
                    tableTitle: this.$t('component.shortcutsModal.labels.title.laboratoryTitleDesktopMode'),
                    tableElements: [
                        {
                            action: this.$t('component.shortcutsModal.labels.action.processElement'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: 'far fa-arrow-down', icon: true }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.processElement')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.undoProcessElement'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: 'far fa-arrow-up', icon: true }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.undoProcessElement')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.assaysLaboratory'),
                            shortcuts: [
                                { key: 'Alt' },
                                { key: 'A' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.assays')
                        }
                    ]
                },
                {
                    tableTitle: this.$t('component.shortcutsModal.labels.title.laboratoryTitleTouchMode'),
                    tableElements: [
                        {
                            action: this.$t('component.shortcutsModal.labels.action.processElement'),
                            shortcuts: [
                                { key: null }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.processElement')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.undoProcessElement'),
                            shortcuts: [
                                { key: null }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.undoProcessElement')
                        }
                    ]
                },
                {
                    tableTitle: this.$t('component.shortcutsModal.labels.title.laboratoryTitleCytology'),
                    tableElements: [
                        {
                            action: this.$t('component.shortcutsModal.labels.action.patientsManagement'),
                            shortcuts: [
                                { key: 'F10' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.patientsManagement')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.pathologicalReport'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: 'Shift' },
                                { key: 'V' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.pathologicalReport')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.voice.saveGrossing'),
                            shortcuts: [
                                { key: 'Alt' },
                                { key: 'S' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.saveGrossing')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.processElement'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: 'far fa-level-down', icon: true }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.processElement')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.toggleSamplesPanel'),
                            shortcuts: [
                                { key: 'F2' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.toggleSamplesPanel')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.sampleDetailsTab'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: '1' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.sampleDetailSection')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.macroscopyTab'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: '2' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.macroSection')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.blocksTab'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: '3' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.blockSection')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.mediaTab'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: '4' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.mediaSection')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.addBlock'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: '+' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.addBlock')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.assayBlock'),
                            shortcuts: [
                                { key: 'Alt' },
                                { key: 'A' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.assays')
                        }
                    ]
                },
                {
                    tableTitle: this.$t('component.shortcutsModal.labels.title.textTemplatesTitle'),
                    tableElements: [
                        {
                            action: this.$t('component.shortcutsModal.labels.action.textTemplates'),
                            shortcuts: [
                                { key: 'Alt' },
                                { key: 'T' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.textTemplates')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.showTemplate'),
                            shortcuts: [
                                { key: null }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.showTemplate')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.nextField'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: 'far fa-arrow-right', icon: true }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.nextField')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.previousField'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: 'far fa-arrow-left', icon: true }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.nextField')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.addTemplate'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: 'far fa-level-down', icon: true }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.addTemplate')
                        }
                    ]
                }
            ]
        }
    }
}
</script>
